import React from 'react'
import { StatCards } from '@/shared/ui'

type Props = {
  availableCents: number
  pendingCents: number
  totalPaidCents: number
  activeClients: number
  uplineActiveClients?: number
  className?: string
}

function cents(v?: number | null) {
  return `R$ ${(Number(v || 0) / 100).toFixed(2)}`
}

export default function AffiliateMasterStatsCards({
  availableCents,
  pendingCents,
  totalPaidCents,
  activeClients,
  uplineActiveClients,
  className,
}: Props) {
  const items = React.useMemo(
    () => [
      {
        label: 'Disponivel para payout (maturado)',
        value: cents(availableCents),
        tone: 'success' as const,
      },
      {
        label: 'Saldo em aberto',
        value: cents(pendingCents),
        tone: 'primary' as const,
      },
      {
        label: 'Total ja pago ao afiliado',
        value: cents(totalPaidCents),
        tone: 'violet' as const,
      },
      {
        label: 'Clientes ativos',
        value: Number(activeClients || 0).toLocaleString('pt-BR'),
        tone: 'warning' as const,
      },
      {
        label: 'Clientes ativos (upline filhos)',
        value: Number(uplineActiveClients || 0).toLocaleString('pt-BR'),
        tone: 'primary' as const,
      },
    ],
    [availableCents, pendingCents, totalPaidCents, activeClients, uplineActiveClients],
  )

  return <StatCards items={items} className={className} />
}
